// extracted by mini-css-extract-plugin
export var width100 = "N_v d_v";
export var design3Pos = "N_xM d_Z";